import { default as domainIntegrationAzureAd }           from './azure-ad/store'
import { default as domainSmartshare }                   from './smartshare/store'
import { default as domainIntegration }                  from './integration/store'
import { default as domainIntegrationDatabricksImport }  from './databricks-import/store'

export default {
	domainSmartshare,
	domainIntegration,
	domainIntegrationAzureAd,
	domainIntegrationDatabricksImport,
}
